module.exports = __webpack_public_path__ + "img/bg.966010d7.png";